import { ComponentProps } from 'react';
import { Layout } from '@/shared/ui/layout';

type Props = ComponentProps<typeof Layout>;

export const Separator = (props: Props) => {
    return <Layout element="hr" {...props} />;
};
